import React from 'react';
import { useTranslation } from 'react-i18next';

import { Edit } from 'jbc-front/components/icons';
import { CLIENT_ALLOWANCE_ITEM_EDIT } from 'src/constants/EndpointUrls';
import { concatParamsToUrl } from 'src/utils/Http';
import { DeleteBtn } from 'src/buttons';
import styles from './AllowanceItemsTable.scss';

const allowanceItemEditUrl = allowanceItem => concatParamsToUrl(CLIENT_ALLOWANCE_ITEM_EDIT, { allowanceItemId: allowanceItem.id });

const AllowanceItemRow = ({ allowanceItem, handleDeleteRow }) => (
  <tr>
    <th>{allowanceItem.name}</th>
    <td>{allowanceItem.unitTypeFormatedValue}</td>
    <td>{allowanceItem.payslipDisplayTypeFormatedValue}</td>
    <td>{allowanceItem.numberOfPayrollRulesGroups}</td>
    <td>
      <div className={styles.buttons}>
        <span>
          <a href={allowanceItemEditUrl(allowanceItem)}>
            <Edit size={20} />
          </a>
        </span>
        {allowanceItem.deletable && (
          <span>
            <DeleteBtn widthAuto handleDelete={() => handleDeleteRow(allowanceItem)} />
          </span>
        )}
      </div>
    </td>
  </tr>
);

const AllowanceItemsTable = ({ allowanceItems, handleDeleteRow }) => {
  const { t } = useTranslation();
  return (
    <div className="l-overflow-scroll">
      <table className="m-table-item m-table-fixed">
        <thead>
          <tr>
            <th width={300}>{t('features.ClientAllowanceItems.components.AllowanceItemEditingForm.item_name')}</th>
            <th width={100}>{t('features.ClientAllowanceItems.components.AllowanceItemsTable.unit')}</th>
            <th width={300}>{t('features.ClientAllowanceItems.components.AllowanceItemsTable.show_in_payslip')}</th>
            <th width={170}>{t('features.ClientAllowanceItems.components.AllowanceItemsTable.applicable_payroll_rule_group')}</th>
            <th width={70}>{t('features.EmployeeBonus.components.ActionButtonSection.edit')}</th>
          </tr>
        </thead>
        <tbody>
          {(!allowanceItems || allowanceItems.length === 0) && (
            <tr>
              <td colSpan={5}>{t('features.EmployeeBonus.components.EmployeeBonusTable.no_data')}</td>
            </tr>
          )}
          {allowanceItems &&
            allowanceItems.map((allowanceItem, index) => (
              <AllowanceItemRow key={allowanceItem.id} index={index} allowanceItem={allowanceItem} handleDeleteRow={handleDeleteRow} />
            ))}
        </tbody>
      </table>
    </div>
  );
};

export default AllowanceItemsTable;
